import React from "react";
import classes from "./OverviewItem.module.css";
import { getTimeAgo } from "../../helpers/NotificationHelpers"; // Assuming you have a utility function to format time
import moment from "moment"; // Import moment.js for date formatting
const OverviewItem = ({ name, data, time }) => {


  
  let notifications = null
  let message = {}
  if (data) message = JSON.parse(data?.message) || "";

  if (data)
    // notifications = JSON.parse(data?.message)
    return (
      <div className={classes["mainWrapper"]}>
        <div className={classes.dataWrapper}>
          <div className={classes["header"]}>
            <span className={["text-in-1-line", classes.heading].join(" ")}>{message?.NotificationTitle}</span>
            <time className={classes.time}>
              {getTimeAgo(data?.createdDate, "short")}
            </time>
          </div>
          <p className={"text-in-2-line"}>

            {message?.ToastMessage}
          </p>

        </div>

        {/* <p>{getTimeAgo(data.createdDate)}</p> */}
      </div>
    );
};

export default OverviewItem;
